export default {
  zh: {
    mySetting: '账户设置',
    logOut: '登出',
    emailSetting: '电子邮件设置',
    setup: '设置',
    search: {
      fuzzy: '模糊搜索',
      phrase: '精确搜索',
    },
  },
  en: {
    mySetting: 'Profile Setting',
    logOut: 'Log Out',
    emailSetting: 'Email Setting',
    setup: 'Setup',
    search: {
      fuzzy: 'Fuzzy Search',
      phrase: 'Phrase Match',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/page/TopPanel/i18n.js